import { CelebritiesPage } from './pages/celebritiesPage';

function App() {
    return (
        <div className='App'>
            <CelebritiesPage></CelebritiesPage>
        </div>
    );
}

export default App;
